import { useCallback, useEffect, useMemo, useState } from 'react'
import { getArtifactPayload } from './artifactPayloadStore.js'
import { DocumentPreviewContext } from './documentPreviewContextValue.js'
import { onDocumentPreviewOpenRequested } from './documentPreviewEvents.js'
import { isRenderable } from './renderableArtifact.js'

/** @param {{ children: import('react').ReactNode }} props */
export function DocumentPreviewProvider({ children }) {
  const [activeArtifact, setActiveArtifact] = useState(null)

  const openPreview = useCallback((selection) => {
    const stored = getArtifactPayload(selection?.artifactId)
    const next = stored ? { ...stored, ...selection } : selection
    if (!isRenderable(next)) return
    setActiveArtifact(next)
  }, [])

  const closePreview = useCallback(() => setActiveArtifact(null), [])

  useEffect(() => onDocumentPreviewOpenRequested(openPreview), [openPreview])

  const isOpen = isRenderable(activeArtifact)

  const value = useMemo(
    () => ({ activeArtifact: isOpen ? activeArtifact : null, isOpen, openPreview, closePreview }),
    [activeArtifact, closePreview, isOpen, openPreview],
  )

  return <DocumentPreviewContext.Provider value={value}>{children}</DocumentPreviewContext.Provider>
}
